import React from "react";

const HeroMarketing = () => {
  return (
    <div className="hero-copy">
      <div className="aekam-pill">
        <span className="aekam-dot">a</span>
        <span>By Aekam AI</span>
      </div>

      <h1>
        Transform customer calls into{" "}
        <span className="accent-red">secure, real-time</span>{" "}
        <span className="accent-teal">digital workflows.</span>
      </h1>

      <h2>Talk. Share. Fill. Verify. Pay. Complete — in the same call.</h2>

      <p className="lede">
        OneHotCode adds a secure digital layer to inbound and outbound enterprise calls,
        enabling agents and customers to exchange documents and data, co-fill forms,
        validate information, collect payments, and complete workflows across web,
        WhatsApp, and other digital channels.
      </p>

      <div className="benefit-grid" aria-label="Core benefits">
        <article className="benefit-card">
          <span className="icon-tile red">⚡</span>
          <strong>
            Reduce call
            <br />
            handling time
          </strong>
        </article>
        <article className="benefit-card">
          <span className="icon-tile teal">▤</span>
          <strong>
            Two-way
            <br />
            form filling
          </strong>
        </article>
        <article className="benefit-card">
          <span className="icon-tile lilac">◇</span>
          <strong>
            Secure document
            <br />
            exchange
          </strong>
        </article>
      </div>

      <div className="lower-grid">
        <article className="workflow-card">
          <div className="workflow-title-row">
            <strong>Customer workflow</strong>
            <span className="live-badge">
              <i></i> Live call
            </span>
          </div>
          <ol>
            <li className="done">
              <span className="status-dot">✓</span>
              <span>Customer connected</span>
              <em>Completed</em>
            </li>
            <li className="done">
              <span className="status-dot">✓</span>
              <span>Form shared</span>
              <em>Completed</em>
            </li>
            <li className="done">
              <span className="status-dot">✓</span>
              <span>Data validated</span>
              <em>Completed</em>
            </li>
            <li className="active">
              <span className="status-dot"></span>
              <span>Payment completed</span>
              <em>In progress</em>
            </li>
          </ol>
        </article>

        <article className="demo-card" id="schedule">
          <img
            src={process.env.PUBLIC_URL + "/assets/img/onehotcode-demo-qr.png"}
            alt="Demo QR code"
          />
          <div>
            <strong>See OneHotCode in action</strong>
            <p>Scan with your phone camera to try a live demo.</p>
            <a
              href="https://calendly.com/onehotcode2026/30min"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open demo →
            </a>
          </div>
        </article>
      </div>
    </div>
  );
};

export default HeroMarketing;
